import { render, staticRenderFns } from "./ReferralGift.vue?vue&type=template&id=524fffe3&scoped=true&"
import script from "./ReferralGift.vue?vue&type=script&lang=js&"
export * from "./ReferralGift.vue?vue&type=script&lang=js&"
import style0 from "./ReferralGift.vue?vue&type=style&index=0&id=524fffe3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524fffe3",
  null
  
)

export default component.exports